<div *ngIf="pageReady" id="page-container">
  <app-top-nav></app-top-nav>
  <main>
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>